/**
 * Formatage d'affichage du stockage (taille, échéance) — PUR, sans i18n de clé.
 *
 * Les UNITÉS de taille (`B`/`kB`/`MB`…) sont des symboles SI, universels (non
 * traduits) ; les DATES sont formatées via `Intl.DateTimeFormat` dans la langue
 * courante (passée par l'appelant, `'fr' | 'de' | 'en'` sont des balises BCP47 valides).
 */

const SIZE_UNITS = ['B', 'kB', 'MB', 'GB', 'TB'] as const;

/** Taille lisible (base 1000, 1 décimale au-delà du kilo). Robuste aux valeurs négatives/NaN. */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  let value = bytes;
  let unit = 0;
  while (value >= 1000 && unit < SIZE_UNITS.length - 1) {
    value /= 1000;
    unit += 1;
  }
  const rounded = unit === 0 ? String(value) : value.toFixed(value >= 100 ? 0 : 1);
  return `${rounded} ${SIZE_UNITS[unit]}`;
}

/** Date/heure d'échéance lisible dans la langue courante. Renvoie l'ISO brut si invalide. */
export function formatDateTime(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
}
